<head>
  <title>Liste consultants client final</title>
  <meta name="description" content="Liste consultants client final">
</head>
<div id="kt_app_content" class="app-content flex-column-fluid">

  <div id="kt_app_content_container" class="app-container container-fluid">
    <!--begin::Card-->
    <div class="card mb-10" >
      <div   class="card-body tools" [formGroup]="searchFormGroup">
        <div class="title mb-3">
          <h4>Recherche</h4>
        </div>
        <div class="row mb-3">
          <div class="col-lg-3">
            <input type="text" name="id" id="id" class="form-control form-control-solid mb-3"
              formControlName="name" placeholder="Nom et prénom">
          </div>
         
          <div class="col-lg-3">
            <input type="text" name="nom" id="nom" formControlName="project_name"
              class="form-control form-control-solid mb-3" placeholder="Projet">
          </div>
          <div class="col-lg-6">
            <div class="mb-3 search-btn d-flex justify-content-start">
              <div class="align-items-center recherche">
                <button type="submit" class="me-5" (click)="applyFilter()">
                  <svg width="15" height="15" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M19.7235 18.263L16.0223 14.5657C18.8541 11.0421 18.5809 5.83122 15.3515 2.63023C13.6625 0.942973 11.4019 0 8.9923 0C6.58271 0 4.34709 0.942973 2.63307 2.63023C0.943993 4.31749 0 6.5756 0 8.98259C0 11.3895 0.943993 13.6228 2.63307 15.3349C4.32216 17.0222 6.58271 17.9652 8.9923 17.9652C11.0293 17.9652 13.0165 17.2704 14.6063 16.005L18.3076 19.7023C18.5064 19.9008 18.7547 20 19.0032 20C19.2764 20 19.5249 19.9008 19.6987 19.7023C20.0962 19.2805 20.0962 18.6601 19.7235 18.2631L19.7235 18.263ZM15.9973 8.95782C15.9973 10.8189 15.2771 12.5807 13.9603 13.8958C12.6438 15.2109 10.88 15.9306 9.01701 15.9306C7.154 15.9306 5.39017 15.2111 4.0737 13.8958C2.75714 12.5806 2.03667 10.8188 2.03667 8.95782C2.03667 7.09682 2.75697 5.3349 4.0737 4.01985C5.39026 2.70472 7.154 1.98502 9.01701 1.98502C10.88 1.98502 12.6438 2.70454 13.9603 4.01985C15.2771 5.33499 15.9973 7.09682 15.9973 8.95782Z"
                      fill="white" />
                  </svg>
                  Rechercher</button>
              </div>
              <div class="reset-icon cursor-pointer"  >
                <a (click)="reset()"> <img src="/assets/media/icons/icon-reset.png" alt="" width="30px"></a>
                </div>
  
            </div>
          </div>
        </div>
        
      </div>
    </div>
    <div class="card">
      <div class="title">
        <h4>Liste des Consultants Externes</h4>
      </div>
      <!--end::Card header-->
      <!--begin::Card body-->
      <div class="card-body pt-0">
        <!--begin::Table-->
        <div class="table-responsive" id="kt_customers_table">
          <table class="table align-middle   fs-6 gy-5 mb-4" >
            <thead>
              <tr class="text-start text-gray-400 fw-bold fs-7 text-uppercase gs-0">

                <th class="min-w-125px"><span>nom et prenom <i (click)="sortData('first_name')" class="fa-solid fa-sort cursor-pointer"></i></span></th>
                <th class="min-w-125px"><span>n° TEL <i (click)="sortData('phone_number')" class="fa-solid fa-sort cursor-pointer"></i></span></th>
                <th class="min-w-125px"><span>EMAIL <i (click)="sortData('email')" class="fa-solid fa-sort cursor-pointer"></i></span></th>
                <th class="min-w-125px"><span>Projet <i (click)="sortData('project_names')" class="fa-solid fa-sort cursor-pointer"></i></span> </th>
                <th class="min-w-125px"><span>ACTION</span></th>
              </tr>
            </thead>
            <tbody class="fw-semibold text-gray-600">
              <tr *ngFor="let consult of listConsultant ">

                <td class="fw-bold">
                  <a  class="first-td name m-0 cursor-pointer"  
                    [routerLink]="['/acceuil/entreprises/esn/details-consultant-esn' , {id:consult.id}]" routerLinkActive="router-link-active" 
                  >{{consult.first_name ? consult.first_name:'---'}} {{consult.last_name ? consult.last_name:'---'}}</a>
                </td>
                <td>
                  <span>{{consult.phone_number?consult.phone_number:'---'}}</span>
                </td>
                <td>
                  <span>{{consult.email?consult.email:'---'}}</span>
                </td>
                <td><span>{{consult?.project_names?consult.project_names:'---'}}</span></td>
                <td>
                  <!-- <div class="seemore">
                    <a class="cursor-pointer" (click)="openModal(details_consultant,consult)">Voir détail</a>
                    <a class="cursor-pointer" (click)="dissocierconsultant(consult.id)">Dissocier consultant</a>
                  </div> -->
                  <div class="tools">
                    <div class="dropdown">
                        <button
                            class="btn btn-sm btn-light btn-flex btn-center btn-active-light-primary dropdown-toggle"
                            type="button" id="dropdownMenuButton"
                            data-bs-toggle="dropdown" aria-haspopup="true"
                            aria-expanded="false">
                            <svg width="19" height="5" viewBox="0 0 19 5"
                                fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="2.44739" cy="2.44739" r="2.44739"
                                    transform="matrix(1 0 0 -1 0 4.89478)"
                                    fill="#265D91" />
                                <circle cx="2.44739" cy="2.44739" r="2.44739"
                                    transform="matrix(1 0 0 -1 6.85254 4.89478)"
                                    fill="#265D91" />
                                <circle cx="2.44739" cy="2.44739" r="2.44739"
                                    transform="matrix(1 0 0 -1 13.7061 4.89478)"
                                    fill="#265D91" />
                            </svg>
                        </button>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                            <a class="dropdown-item cursor-pointer" (click)="openModal(details_consultant,consult)">Voir détail</a>
                            <a class="dropdown-item cursor-pointer" (click)="dissocierconsultant(consult.id)">Dissocier consultant</a>

                        </div>
                    </div>
                   </div>
                </td>

              </tr>
              

            </tbody>
            <!--end::Table body-->
          </table>
          <div class="pagination mt-4" *ngIf="listConsultant && listConsultant.length">
            <app-pagination [data]="listConsultant" [currentPageList]="currentPage" [endexPageList]="endIndex" [lengthData]="totalItems"  (setPages)="getItems($event)">
            </app-pagination>
          </div>
         

          <div class="alert alert-warning text-center mt-5" role="alert"  *ngIf="listConsultant&&!listConsultant.length ">
            <img src="/assets/media/logos/logo-no-data.png" alt="" class="mb-5">
            <span class="empty-list">
             La liste est vide
         </span>
         </div>
        </div>
        <!--end::Table-->
      </div>
      <!--end::Card body-->
    </div>
    <!--end::Card-->
    <!--begin::Modals-->
    <!--begin::Modal - Customers - Add-->

    <!--end::Modal - Customers - Add-->
    <!--begin::Modal - Adjust Balance-->

    <!--end::Modal - New Card-->
    <!--end::Modals-->
  </div>
  <!--end::Content container-->
</div>
<ng-template #details_consultant>
<div class="modal-content" id="details_consultant" tabindex="-1" aria-hidden="true">
  <!--begin::Modal dialog-->
  <div class=" modal-dialog-centered">
    <!--begin::Modal content-->
    <div class="modal-content">
      <!--begin::Form-->
      <form class="form" action="#" id="kt_modal_add_customer_form" aria-disabled="true">
        <!--begin::Modal header-->
        <div class="modal-header" id="kt_modal_add_customer_header">
          <!--begin::Modal title-->
          <h2 class="">Détails consultant</h2>
          <!--end::Modal title-->
          <!--begin::Close-->
          <div id="kt_modal_add_customer_close" class="btn btn-icon btn-sm btn-active-icon-primary">
            <svg (click)="closeModal()" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
              <path d="M14 1L1 14" stroke="#716F6F" stroke-width="1.5" stroke-linecap="round" />
              <path d="M1 1L14 14" stroke="#716F6F" stroke-width="1.5" stroke-linecap="round" />
            </svg>
          </div>
          <!--end::Close-->
        </div>
        <!--end::Modal header-->
        <!--begin::Modal body-->
        <div class="modal-body py-10 px-lg-17">
          <!--begin::Scroll-->
          <div class=" me-n7 pe-7 tools" id="">
            <div class="row">
              <!--begin::Input group-->
              <div class="col-4 fv-row mb-7">
                <label class="d-flex align-items-center form-label mb-2">
                  <span class="">Nom et prénom</span>
                </label>
                <!--end::Label-->
                <input [disabled]="true" type="text" [value]="selectedConsult.fullName" class="form-control form-control-solid"
                 placeholder="nom" name="Nom" />
              </div>
              <!--end::Input group-->
              <!--begin::Input group-->
              <div class="col-4 fv-row mb-7">
                <!--begin::Label-->
                <label class="fs-6 fw-semibold mb-2">
                  <span class="">N° Tel</span>
                </label>
                <!--end::Label-->
                <!--begin::Input-->
                <div class="wrapper" [formGroup]="phoneForm">
                  <ngx-intl-tel-input [cssClass]="'custom'" [disabled]="true"
                      [preferredCountries]="preferredCountries"
                      [enableAutoCountrySelect]="true" [enablePlaceholder]="true"
                      [searchCountryFlag]="true" [searchCountryField]="[
                        SearchCountryField.Iso2,
                        SearchCountryField.Name
                      ]" [selectFirstCountry]="false"
                      [selectedCountryISO]="CountryISO.France" [maxLength]="10"
                      [phoneValidation]="true"
                      [separateDialCode]="separateDialCode"
                      [numberFormat]="PhoneNumberFormat.National" name="phone"
                      formControlName="phone">
                  </ngx-intl-tel-input>
              </div>
                <!--end::Input-->
              </div>
              <div class="col-4 fv-row mb-7">
                <!--begin::Label-->
                <label class="fs-6 fw-semibold mb-2">
                  <span class="">Email </span>
                </label>
                <!--end::Label-->
                <!--begin::Input-->
                <input [disabled]="true" [value]="selectedConsult.email" type="email" class="form-control form-control-solid" placeholder="consultant1@gmail.com"
                  name="email"  />
                <!--end::Input-->
              </div>
            </div>

            <div class="row">
              <!--end::Input group-->
              <!--begin::Input group-->
              <div class="col-4 fv-row mb-7">
                <!--begin::Label-->
                <label class="fs-6 fw-semibold mb-2">Email Professionnel</label>
                <!--end::Label-->
                <!--begin::Input-->
                <input [disabled]="true"  [value]="selectedConsult.email" type="email" class="form-control form-control-solid" placeholder="email-pro@gmail.com"
                  name="email-pro" />
                <!--end::Input-->
              </div>
              <!--end::Input group-->
              <!--begin::Input group-->
              <div class="col-4 fv-row mb-7">
                <!--begin::Label-->
                <label class="fs-6 fw-semibold mb-2">Client</label>
                <!--end::Label-->
                <!--begin::Input-->
                <input [disabled]="true" type="text" class="form-control form-control-solid" placeholder="client" name="description" />
                <!--end::Input-->
              </div>
              <div class="col-4 fv-row mb-7">
                <!--begin::Label-->
                <label class="fs-6 fw-semibold mb-2">Responsable</label>
                <!--end::Label-->
                <!--begin::Input-->
                <input [disabled]="true" type="text" class="form-control form-control-solid" placeholder="responsable"
                  name="description" />
                <!--end::Input-->
              </div>
            </div>
<div class="row">
  <div class="col-4 fv-row mb-7">
    <!--begin::Label-->
    <label class="fs-6 fw-semibold mb-2">TJM</label>
    <!--end::Label-->
    <!--begin::Input-->
    <input [disabled]="true" [value]="selectedConsult.tjm +' €'" type="text" class="form-control form-control-solid" placeholder="15€"
    name="tjm" />
    <!--end::Input-->
  </div>
  <div class="col-4 fv-row mb-7">
    <!--begin::Label-->
    <label class="fs-6 fw-semibold mb-2">Salaire</label>
    <!--end::Label-->
    <!--begin::Input-->
    <input [disabled]="true" type="text" [value]="selectedConsult.desired_salary +' €'" class="form-control form-control-solid" placeholder="4000€"
      name="salaire" />
    <!--end::Input-->
  </div>
  <div class="col-4 fv-row mb-7">
    <!--begin::Label-->
    <label class="fs-6 fw-semibold mb-2">Date début contrat</label>
    <!--end::Label-->
    <!--begin::Input-->
    <div class="position-relative d-flex align-items-center">
      <!--begin::Datepicker-->
        <input [disabled]="true" type="text" placeholder="Date début contrat"
         [value]="!selectedConsult.contract_start_date?'':selectedConsult.contract_start_date |formatDate" class="form-control form-control-solid mb-3"
                      onblur="(this.type='text')">
      <!--end::Datepicker-->
    </div>
    <!--end::Input-->
  </div>
</div>
<div class="row">
  <div class="col-4 fv-row mb-7">
    <!--begin::Label-->
    <label class="fs-6 fw-semibold mb-2">Date début mission</label>
    <!--end::Label-->
    <!--begin::Input-->
    <div class="position-relative d-flex align-items-center">
     
      <!--begin::Datepicker-->
        <input [disabled]="true" type="text" [value]="!selectedConsult.mission_start_date?'':selectedConsult.mission_start_date |formatDate" placeholder="Date début mission" class="form-control form-control-solid mb-3"
                      onblur="(this.type='text')">
      <!--end::Datepicker-->
    </div>
    <!--end::Input-->
  </div><div class="col-4 fv-row mb-7">
    <!--begin::Label-->
    <label class="fs-6 fw-semibold mb-2">Date fin mission</label>
    <!--end::Label-->
    <!--begin::Input-->
    <div class="position-relative d-flex align-items-center">
      <!--begin::Datepicker-->
        <input [disabled]="true" [value]="!selectedConsult.mission_end_date?'':selectedConsult.mission_end_date |formatDate" type="text" placeholder="Date fin mission" class="form-control form-control-solid mb-3"
                      onblur="(this.type='text')">
      <!--end::Datepicker-->
    </div>
    <!--end::Input-->
  </div>
</div>



          </div>
          <!--end::Scroll-->
        </div>
      </form>
    </div>
  </div>
</div>
</ng-template>

